module.exports = __webpack_public_path__ + "static/media/29ADMSPC6.313edd34.jpg";